export default "__VITE_ASSET__DiL$hLQv__"